if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
        document.addEventListener("shopify:block:select", (evt) => {
          const blockId = evt.detail?.blockId;
          if (blockId) {
            const targetTrigger = this.querySelector(`[data-block-id="${blockId}"]`) || this.querySelector(`[data-tab*="${blockId}"]`);
            if (targetTrigger) {
              targetTrigger.click();
            }
          }
        });
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.querySelectorAll(".product__tab--trigger").forEach(
        tabTrigger => {
          tabTrigger.addEventListener("click", evt => {
            evt.preventDefault();
            this.openTab(
              evt,
              tabTrigger.dataset.tab
            );
          });
        }
      );

      this.openDefaultTab();
    }

    openDefaultTab() {
      const defaultTab = this.querySelector(".product__tab[data-default-open]") || this.querySelector(".product__tab--trigger");
      if (defaultTab) {
        defaultTab.click();
      }
    }

    openTab(evt, tabName) {
      const tabcontents = this.querySelectorAll(
        ".product__tab-content"
      );
      tabcontents.forEach(content => {
        content.style.display = "none";
      });

      const tablinks = this.querySelectorAll(".product__tab");
      tablinks.forEach(link => {
        link.classList.remove("active");
      });

      const currentTabContent = this.querySelector(`#${tabName}`);

      if (currentTabContent) {
        currentTabContent.style.display = "block";
        const trigger = (evt && evt.currentTarget) || this.querySelector(`.product__tab[data-tab="${tabName}"]`);
        if (trigger) {
          trigger.classList.add("active");
        }
      }
    }
  }
  customElements.define("product-tabs", ProductTabs);
}
